var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallPurpleWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1769.082,
    height: 89.721,
    viewBox: "0 0 1769.082 89.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2768",
    "data-name": "Path 2768",
    d: "M1409.4,526.217V467.032c-81.192-8.784-399.688-38.726-451.682,25.793-59.681,74.059-219.1-26.569-319.74-14.5-63.4,7.6-78.469,15.085-67.328,21.447,7.015,4.012,22.878,7.524,43.467,10.542,16.808,2.464,24.395,5.481,20.673,8.29-9.539,7.257-80.728,14.4-243.242,15.062-232.833.956-248.94-28.674-340.719-31.94-18.356-.654-142.882,25.153-160.774,24.835C-182.3,525.279-248.125,526.415-276.3,528c-32.795,1.85-77.283,2.862-83.375,2.989.045,7.515.044,4.446.133,11.147H1409.4C1409.421,531.813,1409.4,535.011,1409.4,526.217Z",
    transform: "translate(359.673 -452.418)",
    fill: "#efeffa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallPurpleWave);
export default __webpack_public_path__ + "static/media/smallPurpleWave.6f8d8e02b6bc690536acda2acf5af09d.svg";
export { ForwardRef as ReactComponent };